<template>
	<div>
		<a-row>
			<a-col :span="10">
				<div class="banner-title"><h3>首页轮播图</h3></div>
				
				<el-upload
					list-type="picture-card"
					:action="domain"
					:data="QiniuData"
					:on-error="uploadError"
					:on-success="uploadSuccess"
					:before-upload="beforeAvatarUpload"
					:limit="6"
					multiple
					:on-exceed="handleExceed"
					:file-list="bannerList"
				>
					<i slot="default" class="el-icon-plus">
						<div style="font-size: 14px;">
							轮播图(6张)
						</div>
					</i>
					<div slot="file" slot-scope="{ file }">
						<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
							<span v-if="!disabled" class="el-upload-list__item-delete" @click="bannerRemove(file)"><i class="el-icon-delete"></i></span>
						</span>
					</div>
				</el-upload>
				<el-dialog :visible.sync="dialogVisible"><img width="70%" :src="dialogImageUrl" alt="" /></el-dialog>
				
				<div class="banner-title"><h3>商会Logo</h3></div>
				
				
				<el-upload
					list-type="picture-card"
					:action="domain"
					:data="QiniuData"
					:on-error="uploadError"
					:on-success="uploadSuccessLogo"
					:before-upload="beforeAvatarUploadLogo"
					:limit="1"
					multiple
					:on-exceed="handleExceed"
					:file-list="logoList"
				>
					<i slot="default" class="el-icon-plus">
						<div style="font-size: 14px;">
							logo(1张)
						</div>
					</i>
					<div slot="file" slot-scope="{ file }">
						<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
							<span v-if="!disabled" class="el-upload-list__item-delete" @click="logoRemove(file)"><i class="el-icon-delete"></i></span>
						</span>
					</div>
				</el-upload>
				
				<div class="banner-title"><h3>商会图片展示</h3></div>
				
				<el-upload
					list-type="picture-card"
					:action="domain"
					:data="QiniuData"
					:on-error="uploadError"
					:on-success="uploadSuccessImg"
					:before-upload="beforeAvatarUploadImg"
					:limit="15"
					multiple
					:on-exceed="handleExceed"
					:file-list="logoList"
				>
					<i slot="default" class="el-icon-plus">
						<div style="font-size: 14px;">
							商会图片
						</div>
					</i>
					<div slot="file" slot-scope="{ file }">
						<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
						<span class="el-upload-list__item-actions">
							<span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)"><i class="el-icon-zoom-in"></i></span>
							<span v-if="!disabled" class="el-upload-list__item-delete" @click="imgRemove(file)"><i class="el-icon-delete"></i></span>
						</span>
					</div>
				</el-upload>
				
				<div class="banner-title"><h3>商会资料</h3></div>
				<a-form :form="form">
					<a-form-item label="商会名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input v-decorator="['commerceName', { rules: [{ required: true, message: '请输入工厂名称!' }] }]" placeholder="请输入工厂名称" />
					</a-form-item>
					<a-form-item label="商会介绍" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-textarea v-decorator="['intro', { rules: [{ required: true, message: '请输入企业介绍!' }] }]" placeholder="请填写企业介绍...." :rows="6" />
					</a-form-item>
					<a-form-item label="商会地址" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
						<a-input v-decorator="['addressDetail', { rules: [{ required: true, message: '请输入企业地址!' }] }]" placeholder="请输入企业地址" />
						<Map class="map" @localhostMap="localhostMap"></Map>
					</a-form-item>
					<a-button type="button" id="submit-save" @click="handleSubmit" style="margin-top: 5px;display:none;" size="large"></a-button>
				</a-form>
				
			</a-col>
		<!-- 	<a-col :span="10" class="preview_phone">
				<div class="phone-body">
					<div class="storeBanner">
						<a-carousel :afterChange="onChange" autoplay>
							<div v-for="(item, index) in bannerList" :key="index">
								<div><img class="banner-img" :src="item.url" alt="" /></div>
							</div>
						</a-carousel>
					</div>
					<a-row class="store-title mobile">
						<a-col :span="4" class="title-avatar"><a-avatar :size="35" :src="data.logo" /></a-col>
						<a-col :span="13">
							<div class="title-company-name">{{ data.name }}</div>
							<div><img style="width: 51px;" src="http://cdn.diqwl.com/store_banner_company-rz.png" alt="" /></div>
						</a-col>
						<a-col :span="7">
							<div>
								<button class="all_list_brands_title_details_btn" id="brands_button">
									<span class="glyphicon">
										<a-icon type="plus" />
										<span style="font-size: 10px;">关注企业</span>
									</span>
								</button>
							</div>
						</a-col>
					</a-row>
					<div class="line mobile"></div>
					<div class="store-info mobile">
						<div class="info-title">
							<div>
								<img src="../../static/left.png" alt="" />
								<span>基本资料</span>
								<img src="../../static/right.png" alt="" />
							</div>
						</div>
						
					</div>
				</div>
				<div class="hint">
					<a-icon type="warning" />
					该模型仅供参考，具体展示以手机为主
				</div>
			</a-col> -->
			<a-col :span="10">
				<a-affix :offset-top="10" :offset-bottom="0">
					<div class="submit-save">
						<a-form-item :wrapper-col="{ span: 12, offset: 5 }">
							<a-alert message="点击保存" description="保存后即刻对数据进行更改,请谨慎操作" type="warning" showIcon />
							<a-button type="primary" style="margin-top: 5px;" @click="submitSave()" html-type="submit" size="large">保存</a-button>
						</a-form-item>
					</div>
				</a-affix>
				
			</a-col>
		</a-row>
	</div>
</template>

<script>
	import axios from 'axios';
	import Map from '../utils/map.vue';
	import api from '../../api/Api.js';
	
export default {
	components: {
		Map
	},
	data() {
		return {
			previewVisible: false,
			previewImage: '',
			pictureAddress: '',
			bannerList: [],
			logoList: [],
			imgList:[],
			domain: 'https://upload-z2.qiniup.com', // 七牛云的上传地址（华南区）
			qiniuaddr: 'http://cdn.diqwl.com', // 七牛云的图片外链地址
			QiniuData: {
				key: '', //图片名字处理
				token: '' //七牛云token
			},
			data: {
				logo: '',
				name: '',
				type: 'COMMERCE',
				intro:'',
				img: '',
				address:'',
				longitude:'',
				latitude:'',
				cover:''
			},
			form: this.$form.createForm(this, { name: 'dynamic_rule' }),
			dialogImageUrl: '',
			dialogVisible: false,
			disabled: false
		};
	},
	mounted() {
		this.getInfo();
		this.getQiniuToken()
	},
	methods: {
		submitSave() {
			document.getElementById('submit-save').click();
		},
		getInfo() {
			const that = this;
			let url = 'api/commerce/v1/admin/info';
			let parm = 1;
		
			api.postRequest(url, parm, res => {
				console.log(res);
		
				const rest = res.data;
				if (rest.status == 200) {
					this.bannerInfo(rest.data.cover);
					this.imgInfo(rest.data.img);
					this.formInfo(rest.data);
					this.logoInfo(rest.data.logo);
					that.data = rest.data;
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		modifyInfo() {
			let url = 'api/commerce/v1/admin/modify';
			let parm = this.data;
		
			api.postRequest(url, parm, res => {
				const rest = res.data;
				if (rest.status == 200) {
					this.$message.success('修改成功！');
				} else {
					this.$message.error('服务器内部错误！');
				}
			});
		},
		handleCancel() {
			this.previewVisible = false;
		},
		handlePreview(file) {
			this.previewImage = file.url || file.thumbUrl;
			this.previewVisible = true;
		},
		handleChange({ fileList }) {
			this.fileList = fileList;
		},
		onChange(a, b, c) {
			console.log(a, b, c);
		},
		localhostMap(localDate) {
			this.form.setFieldsValue({
				addressDetail: localDate.address
			});
			this.data.address = localDate.address;
			this.data.longitude = localDate.longitude;
			this.data.latitude = localDate.latitude;
			console.log(this.address);
		},
		handleSubmit(e) {
			const that = this;
		
			this.$confirm({
				title: '确定保存吗？',
				content: '点击保存之后，您的数据将会即刻更改，谨慎操作！',
				onOk() {
					if (that.checkUrl()) {
						this.$message.error('图片信息不完善！');
						return;
					}
					const bannerList = [];
					const imgList = [];
					that.bannerList.forEach((item, index, array) => {
						bannerList.push(item.url);
					});
					that.imgList.forEach((item, index, array) => {
						imgList.push(item.url);
					});
		
					e.preventDefault();
					that.form.validateFields((err, values) => {
						
						if (!err) {
							values.establishDate = that.establishDate;
							that.data = {
								addressDetail: values.addressDetail,
								cover: bannerList,
								img: imgList,
								intro: values.intro,
								logo: that.logoList[0].url,
								name: values.commerceName,
								address: that.data.address,
								longitude: that.data.longitude,
								latitude: that.data.latitude,
							};
							that.modifyInfo();
						}
		
						return new Promise((resolve, reject) => {
							setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
						}).catch(() => console.log('Oops errors!'));
					});
				},
				onCancel() {
					that.$message.warning('你点击了取消');
				}
			});
		
			console.log('确认提交');
		},
		checkUrl() {
			if (this.bannerList.length == 0 || this.logoList.length == 0) {
				return true;
			}
			return false;
		},
		beforeAvatarUpload(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeAvatarUploadLogo(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		beforeAvatarUploadImg(file) {
			const isPNG = file.type === 'image/png';
			const isJPEG = file.type === 'image/jpeg';
			const isJPG = file.type === 'image/jpg';
			const isLt2M = file.size / 1024 / 1024 < 2;
		
			if (!isPNG && !isJPEG && !isJPG) {
				this.$message.error('上传头像图片只能是 jpg、png、jpeg 格式!');
				return false;
			}
			if (!isLt2M) {
				this.$message.error('上传头像图片大小不能超过 2MB!');
				return false;
			}
			this.QiniuData.key = localStorage.getItem('accountId')+Date.parse(new Date());
			this.pictureAddress = this.qiniuaddr + '/' + this.QiniuData.key;
		},
		//请求后台拿七牛云token
		getQiniuToken() {
			axios({
				method: 'post',
				url: '/api/file/v1/qiniu/getToken',
				data: JSON.stringify({
					param: '1'
				}),
				headers: {
					"authCode":'GJaImrLgzbgKQ0GaNX5kgCDtPrk7mcdF6Kq2zxe62pU=',
					'Content-Type': 'application/json',
					token: localStorage.getItem('accessToken'),
					"device": 'admin'
				}
			}).then(res => {
				if (res.data.status == 200) {
					this.QiniuData.token = res.data.data.token;
				} else {
					this.$message.error('服务器内部错误');
				}
			});
		},
		bannerRemove(file) {
			var index = this.bannerList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.bannerList.splice(index, 1);
		},
		logoRemove(file) {
			var index = this.logoList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.logoList.splice(index, 1);
		},
		imgRemove(file) {
			var index = this.imgList.findIndex(item => {
				if (item.uid == file.uid) {
					return true;
				}
			});
			this.imgList.splice(index, 1);
		},
		bannerInfo(bannerList) {
			if (bannerList == null) {
				return;
			}
			bannerList.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.bannerList.push(obj);
			});
		},
		logoInfo(logoList) {
			if (logoList == null) {
				return;
			}
			var obj = {
				status: 'done'
			};
			obj.uid = 1;
			obj.name = 'logo.jpg';
			obj.url = logoList;
			this.logoList.push(obj);
		},
		imgInfo(imgInfo) {
			if (imgInfo == null) {
				return;
			}
			imgInfo.forEach((item, index, arr) => {
				var obj = {
					status: 'done'
				};
				obj.uid = index;
				obj.name = index + '.jpg';
				obj.url = item;
				this.imgList.push(obj);
			});
		},
		formInfo(rest) {
			if (rest.name == undefined) {
				console.log("返回")
				return;
			}
			this.form.setFieldsValue({
				commerceName: rest.name,
				addressDetail: rest.addressDetail,
				intro: rest.intro
			});
		},
		uploadSuccess(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.bannerList.push(obj);
		},
		uploadSuccessLogo(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.logoList.push(obj);
		},
		uploadSuccessImg(response, file, fileList) {
			this.uploadPicUrl = `${this.qiniuaddr}/${response.key}`;
			var obj = {
				status: 'done'
			};
			obj.uid = file.uid;
			obj.name = this.QiniuData.key;
			obj.url = this.pictureAddress;
			this.imgList.push(obj);
		},
		uploadError(err, file, fileList) {
			this.$message({
				message: '上传出错，请重试！',
				type: 'error',
				center: true
			});
		},
		handlePictureCardPreview(file) {
			this.dialogImageUrl = file.url;
			this.dialogVisible = true;
		},
		handleExceed(files, fileList) {
			this.$message.warning(`图片选择已上限，如需更换，请删除上一张图片在重新选择！`);
		},
	}
};
</script>
<style scoped>
/* banner-title */
.banner-title {
	border-bottom: 2px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
.map{
	width: 500px;
	height: 450px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
.preview_phone {
	width: 670px;
	height: 670px;
	background-image: url('../../static/phone.png');
	background-size: 100%;
}

/* For demo */
.ant-carousel >>> .slick-slide {
	text-align: center;
	height: 160px;
	line-height: 160px;
	background: #364d79;
	overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
	color: #fff;
}

.submit-save {
	margin-top: 40px;
}

.hint {
	margin-top: 85px;
	font-size: 22px;
	text-align: center;
}

.company-info {
	height: 100%;
	padding: 1%;
}
.company-img img {
	width: 235px;
	margin-top: 10px;
}

.info-intro {
	height: 40px;

	text-overflow: -o-ellipsis-lastline;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-line-clamp: 2;
	-webkit-box-orient: vertical;
}

/* banner-title */
.banner-title {
	border-bottom: 2px solid gray;
	margin-bottom: 30px;
	margin-top: 10px;
}
.map {
	height: 450px;
	width: 700px;
	margin-top: 20px;
}

/* you can make up upload button and sample style by using stylesheets */
.ant-upload-select-picture-card i {
	font-size: 32px;
	color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
	margin-top: 8px;
	color: #666;
}
.preview_phone {
	width: 670px;
	height: 670px;
	background-image: url('../../static/phone.png');
	background-size: 100%;
}
.phone-body {
	height: 462px;
	overflow: scroll;
	margin-top: 102px;
}
.phone-body::-webkit-scrollbar {
	display: none;
}

/* For demo */
.ant-carousel >>> .slick-slide {
	text-align: center;
	height: 127.5px;
	line-height: 160px;
	background: #364d79;
	overflow: hidden;
}

.ant-carousel >>> .slick-slide h3 {
	color: #fff;
}

.storeBanner {
	width: 255px;
	margin: 0 auto;
}

.banner-img {
	width: 260px;
}

.store-title {
	height: 55px;
}
.title-avatar {
	height: 55px;
	padding-top: 10px;
	padding-left: 5px;
}
.title-company-name {
	padding-top: 8px;
	font-size: 12px;
	font-weight: bold;
}

.mobile {
	width: 255px;
	margin: 0 auto;
}
.line {
	border: 2px solid gainsboro;
}
.store-info {
	height: 160px;
}
.info-title {
	height: 20px;
	text-align: center;
	font-weight: bold;
	margin-top: 5px;
}
.info-content {
	padding: 3%;
	height: 100%;
	font-size: 12px;
}

.all_list_brands_title_details_btn {
	width: 71px;
	height: 25px;
	font-size: 9px;
	line-height: 1.428571429;
	border-radius: 15px;
	margin-top: 10px;
	float: left;
	background-image: linear-gradient(to left, Orange, DarkOrange);
	border: 1px solid #f4a460;
	color: white;
}

.info-icon {
	display: inline;
	float: left;
	margin-top: 5px;
	margin-left: 5px;
	font-weight: bold;
	width: 100%;
}
.icon {
	width: 20px;
	display: inline;
	float: left;
}

.icon-right-text {
	margin-left: 15px;
	font-size: 12px;
	float: left;
}

.honor-info {
	height: 145px;
}

.honor-info-img {
	overflow-x: auto; /*	设置x轴可滑动 */
	list-style: none; /*去掉li上的小点 */
	white-space: nowrap; /*元素不换行 */
	width: auto;
	padding: 0;
}
.item {
	margin-left: 20px;
	display: inline-block; /*让所有的li在一行 注意这里不能用*/
	float: left; /* 因为设置float后里超过一屏后会自动换行 */
	padding: 0;
	margin-top: 10px;
}

.honor-info-img img {
	width: 150px;
	margin-left: 10px;
}

.honor-info-img::-webkit-scrollbar {
	display: none;
}
</style>
